<template>
  <div class="connect-instruction-egisz">
    <h2 class="connect-instruction-egisz__title">
      Как подключить модуль ЕГИСЗ в МИС?
    </h2>
    <section class="connect-instruction-egisz__section">
      <h3 class="connect-instruction-egisz__subtitle">
        Заключите договор с оператором передачи данных ЕГИСЗ
      </h3>
      <div class="connect-instruction-egisz__sub-content">
        <p class="connect-instruction-egisz__text">
          Если вы хотите подключить модуль ЕГИСЗ, сообщите менеджеру техподдержки МИС 32top
          в чат или мессенджеры. Менеджер направит ваш контакт Медфлекс — оператору передачи
          данных в&nbsp;ЕГИСЗ, с&nbsp;ним необходимо заключить договор.
        </p>
        <h4 class="connect-instruction-egisz__list-title">
          Условия заключения договора с Медфлекс:
        </h4>
        <ul class="connect-instruction-egisz__list">
          <li>у клиники или кабинета должен быть 1 юридический адрес и 1 юридическое лицо</li>
          <li>
            клиника должна иметь регистрацию на сервисе Продокторов
            (это бесплатно, с&nbsp;подключением помогут специалисты Медфлекс)
          </li>
          <li>
            клиника должна иметь вывеску и собственный сайт/ актуальную информацию
            в Яндекс.Картах и 2ГИС
          </li>
        </ul>
      </div>
    </section>
    <section class="connect-instruction-egisz__section">
      <h3 class="connect-instruction-egisz__subtitle">
        Подключение клиники к подсистеме РЭМД
      </h3>
      <div class="connect-instruction-egisz__sub-content">
        <p class="connect-instruction-egisz__text">
          После заключения договора с оператором передачи данных в&nbsp;ЕГИСЗ необходимо
          дождаться рассмотрения заявки о подключении клиники к&nbsp;подсистеме РЭМД.
        </p>
        <p class="connect-instruction-egisz__warning">
          <strong>Внимание!</strong>
          <span>
            Рассмотрение заявки РЭМД занимает <b>от 2 до 3 недель</b>,
            поэтому рекомендуется еще на этапе заключения договора с&nbsp;оператором данных
            подготовить все необходимые документы.
          </span>
        </p>
        <h4 class="connect-instruction-egisz__list-title">
          Помните, что подключение к РЭМД возможно только при наличии:
        </h4>
        <ul class="connect-instruction-egisz__list">
          <li>регистрации клиники в <b>ФРМО</b></li>
          <li>регистрации врачей в <b>ФРМР</b></li>
          <li><b>ЭЦП</b> у клиники и врачей</li>
        </ul>
      </div>
    </section>
    <section class="connect-instruction-egisz__section">
      <h3 class="connect-instruction-egisz__subtitle">
        Включение модуля в МИС 32top
      </h3>
      <div class="connect-instruction-egisz__sub-content">
        <p class="connect-instruction-egisz__text">
          Когда клиника будет подключена к РЭМД, сотрудник Медфлекс сообщит вам.
        </p>
        <p class="connect-instruction-egisz__text">
          Напишите менеджеру техподдержки МИС 32top о том, что все необходимые этапы пройдены
          и клиника готова к передаче данных. Мы включим модуль ЕГИСЗ со&nbsp;своей стороны
          и вы сможете отправлять данные в&nbsp;ЕГИСЗ.
        </p>
      </div>
    </section>
    <support-contacts
      class="tariffs__support"
      title="Отдел поддержки"
      is-show-mini-button-max
      is-show-mini-button-telegram
      v-bind:is-show-large-button-whats-app="false"
      v-bind:phone-href="this.$options.supportPhoneHref"
      v-bind:phone-title="this.$options.supportPhoneTitle"
      v-bind:support-data-email="{
        title: $options.helpEmailTitle,
        href: $options.helpEmailHref,
      }"
    />
  </div>
</template>

<script>
import aboutMixin from '@/mixins/aboutMixin';
import SupportContacts from '@/components/SupportContacts.vue';

/**
 * @description Инструкция по подключению модуля ЕГИСЗ.
 * @type {Vue}
 */
export default {
  /**
   * @description Инструкция подключения модуля ЕГИСЗ.
   */
  name: 'ConnectInstructionEGISZ',
  components: {
    SupportContacts,
  },
  mixins: [
    aboutMixin,
  ],
};
</script>

<style scoped lang="scss">
.connect-instruction-egisz {
  max-width: 1220px;
  margin-top: 20px;
  counter-reset: section 0;

  &__title {
    margin-bottom: 24px;
    font-size: 24px;
    font-weight: 400;
    color: var(--reading-color);
  }

  &__section {
    margin-bottom: 32px;
  }

  &__subtitle {
    display: flex;
    align-items: center;
    column-gap: 5px;
    margin-bottom: 12px;
    padding: 20px 40px;
    font-size: 18px;
    font-weight: 600;
    color: var(--action-color);
    background-color: var(--section-background-color);
    border-radius: 5px;
    counter-increment: section 1;
    &::before {
      content: counter(section)". ";
    }
  }

  &__sub-content {
    padding-left: 40px;
  }

  &__text {
    margin-bottom: 16px !important;
    line-height: 1.6;
    color: #323c47;
  }

  &__warning {
    flex-direction: column;
    margin-bottom: 16px !important;
    color: #323c47;
    line-height: 1.6;
    strong {
      color: var(--action-color);
    }
  }

  &__list-title {
    font-weight: 600;
    color: #323c47;
    margin-bottom: 8px;
  }

  &__list {
    line-height: 1.6;
    color: #323c47;
    padding-left: 24px;

    li {
      margin-bottom: 6px;
    }
  }
}
</style>
